import { useParams } from "react-router-dom";
import { useRoom } from "../../../hooks/cabinet";
import { PageHeader } from "../../../components/PageHeader/PageHeader";
import { useEffect, useState } from "react";
import Modal from "../../../components/Modal/Modal";
import QRCode from "react-qr-code";
import maleTeacherProfile from "../../../assets/png/male-teacher-profile.png";
import fiveStars from "../../../assets/png/five-stars.png";
import { teachers } from "../../../misc/constants";
import { getHHMMFromDateString, getRandomFromArray } from "../../../misc/utils";
import { useLessonByRoomName } from "../../../hooks/lesson";
import QR from "../../../assets/icons/QR";

export const Cabinet = () => {
  const { id } = useParams();
  const room = useRoom(id);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [trigger, setTrigger] = useState(0);
  const lesson = useLessonByRoomName(room.name, trigger);

  useEffect(() => {
    setTrigger((t) => t + 1);
  }, [qrModalOpen]);

  return (
    <div className="grid grid-cols-12 pt-5 px-10">
      <div className="col-span-12 mb-4">
        <PageHeader />
      </div>
      <div className="col-span-12 flex flex-row justify-end mb-4">
        <button
          className="rounded-[10px] border border-[#549BA7] py-[11px] px-6 flex flex-row items-center"
          onClick={() => setQrModalOpen(true)}
        >
          <QR additionalStyle="text-green-500" />
          <p className="text-[#2C6A75] text-xs leading-[18px] font-semibold ml-2">
            QR code кабинета
          </p>
        </button>
      </div>
      <div className="col-span-12 grid grid-cols-12">
        <div className="col-span-12 bg-white py-2.5 px-5 rounded-[5px] shadow-container-1 flex flex-col">
          <p className="font-medium text-lg text-black">Кабинет {room.name}</p>
        </div>
        <div className="col-span-4 mt-4 pr-2">
          <div className="bg-white p-4 rounded-[10px] shadow-container-1 flex flex-col">
            <div className="flex flex-col pb-1 border-b border-b-[#D9D9D9]">
              <p className="text-xs font-medium text-black">
                Последний использовал кабинет
              </p>
            </div>
            <div className="flex flex-row mt-3">
              <img src={maleTeacherProfile} className="w-[55px] h-[50px]" />
              <div className="flex flex-col ml-3.5">
                <p className="font-bold text-xs text-black">
                  {lesson && "teacher_data" in lesson
                    ? `${lesson.teacher_data.lastname} ${lesson.teacher_data.firstname}`
                    : getRandomFromArray(teachers)}
                </p>
                <p className="text-[12px] italic text-[#979797]">
                  {lesson && "description" in lesson
                    ? `${lesson.description}, ${getHHMMFromDateString(
                        lesson.start_time
                      )} - ${getHHMMFromDateString(lesson.end_time)}`
                    : `нарративный дизайн, суббота 08:00 - 10:00`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-4 mt-4 px-2">
          <div className="bg-white p-4 rounded-[10px] shadow-container-1 flex flex-col">
            <div className="flex flex-col pb-1 border-b border-b-[#D9D9D9]">
              <p className="text-xs font-medium text-black">
                Средние часы активности
              </p>
            </div>
            <div className="flex flex-col flex-1 mt-5 justify-end">
              <p>
                <span className="text-[35px] leading-[42px] font-semibold text-[#549BA7]">
                  28
                </span>
                <span className="ml-2.5 text-[10px] leading-3 italic text-[#979797]">
                  часов в неделю
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-4 mt-4 pl-2">
          <div className="bg-white p-4 rounded-[10px] shadow-container-1 flex flex-col">
            <div className="flex flex-col pb-1 border-b border-b-[#D9D9D9]">
              <p className="text-xs font-medium text-black">Рейтинг кабинета</p>
            </div>
            <div className="flex flex-col flex-1 mt-2.5 justify-end">
              <img src={fiveStars} className="w-[52px] h-3.5" />
              <p>
                <span className="text-[30px] leading-[36px] italic font-bold text-[#549BA7]">
                  5
                </span>
                <span className="ml-[3px] text-[15px] leading-[18px] font-light italic text-[#979797]">
                  /5
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <Modal
        dimensions="w-2/5 rounded-[10px] p-7"
        visible={qrModalOpen}
        setVisible={setQrModalOpen}
      >
        <div className="flex flex-row justify-center">
          <QRCode
            value={JSON.stringify({
              type: "CreateLesson",
              roomName: room.name,
              roomId: room.id,
            })}
          />
        </div>
      </Modal>
    </div>
  );
};
